/**
 * useTokenBalance — live `tokenBalance` for the given user.
 *
 * Subscribes to `users/{uid}` and returns `{ balance, loading }`.
 * Shared by Header `TokenBalance` widget and per-panel `TokenSpendIndicator`.
 * Returns balance = null when no uid is provided (signed-out).
 */
import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { firestore } from "../FirebaseConfig";

export default function useTokenBalance(uid) {
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(Boolean(uid));

  useEffect(() => {
    if (!uid) {
      setBalance(null);
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const ref = doc(firestore, "users", uid);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        setBalance(snap.exists() ? snap.data().tokenBalance || 0 : 0);
        setLoading(false);
      },
      () => {
        setBalance(0);
        setLoading(false);
      },
    );
    return () => unsub();
  }, [uid]);

  return { balance, loading };
}
